/**
 * 语音翻译语言 API
 * 复用 CR Batch 1 L1 端点：/cr/recognition/list、/cr/trans/list（request 解包后即为分组数组）
 */

import { request } from '@/shared/api/request'

export interface LangItem {
  languageCode: string
  languageName: string
  languageEnName?: string
  linkCode?: string
  lanText?: string
  /** 表内 NA_NAME 简写（如 en、zh、ja），与 cr_language_init.sql 一致 */
  shortCode?: string
  /** 供 Azure 语音翻译使用的目标语言代码（zh-CN->zh-Hans，其余用 shortCode） */
  azureTargetCode?: string
  /** 是否支持作为发言/识别源；缺省按 true 兼容旧端点 */
  sttSupported?: boolean
}

export interface LanguageGroup {
  letter: string
  languageList?: LangItem[]
  languages?: LangItem[]
}

/** L1 unwrap 后 data 形态 */
export type LanguageListResponse = LanguageGroup[]

/**
 * 获取识别语言列表（源语言）
 */
export function getRecognitionLangs(token: string, en = 0): Promise<LanguageListResponse> {
  return request<LanguageListResponse>({
    url: '/cr/recognition/list',
    method: 'get',
    params: { token, en }
  })
}

/**
 * 获取翻译语言列表（目标语言）
 */
export function getTransLangs(token: string, en = 0): Promise<LanguageListResponse> {
  return request<LanguageListResponse>({
    url: '/cr/trans/list',
    method: 'get',
    params: { token, en }
  })
}
